import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { EDIT_PROFILE, GET_PROFILE } from "./actionTypes"
import {
  profileSuccess,
  profileError,
  getUserProfileSuccess,
  getUserProfileFail
} from "./actions"

import { getUserProfileApi, updateUserProfileApi } from "../../../helpers/backend_helper"

function* editProfile({ payload: { user } }) {
  try {
    const response = yield call(updateUserProfileApi, user)
    yield put(profileSuccess({ data: response }))

    // Refresh the profile data after update
    yield call(getUserProfile)
  } catch (error) {
    console.error("Profile update error:", error);
    yield put(profileError(error.message || "Update profile failed"))
  }
}

function* getUserProfile() {
  try {
    const response = yield call(getUserProfileApi)
    yield put(getUserProfileSuccess(response.data || response))
  } catch (error) {
    if (error.response?.status !== 404) {
      console.error("Error fetching user profile:", error);
      yield put(getUserProfileFail(error.message || "Failed to fetch user profile"))
    }
  }
}

export function* watchProfile() {
  yield takeEvery(EDIT_PROFILE, editProfile)
  yield takeEvery(GET_PROFILE, getUserProfile)
}

function* ProfileSaga() {
  yield all([fork(watchProfile)])
}

export default ProfileSaga
